import React, { useCallback } from "react";
import ClickOutside from "react-click-outsider";
import { useNavigate } from "react-router-dom";
import {
  translate,
  UserPermissionByIdResponse,
  useAuthentication,
  useFeatureFlag,
} from "@shape/reef-shared";
// import { hasPermission } from "utils/permissions";
import { MenuContainer, MenuOptions } from "./styled";

interface UserMenuProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  user?: UserPermissionByIdResponse;
  username: string;
}

const UserMenu: React.FC<UserMenuProps> = ({
  isOpen,
  setIsOpen,
  user,
  username,
}: UserMenuProps) => {
  const navigate = useNavigate();
  const { logout } = useAuthentication();
  const canAccessUsersPermission = useFeatureFlag("can-access-users-permission");

  const handleLogout = useCallback(() => {
    logout();
  }, [logout]);

  // const hasManageRequestPermission = hasPermission(
  //   user?.user_groups,
  //   OthersPermissions.MANAGE_REQUEST
  // );

  const renderOption = (label: string, action: () => void) => {
    const doActionAndClose = () => {
      setIsOpen(false);
      action();
    };

    return (
      <div
        onClick={doActionAndClose}
        onKeyDown={(e) => e.keyCode === 13 && doActionAndClose()}
        role="button"
        tabIndex={0}
      >
        {translate(label, label)}
      </div>
    );
  };

  return (
    <ClickOutside onClickOutside={() => setIsOpen(false)}>
      {isOpen && username && (
        <MenuContainer data-testid="user-menu">
          <MenuOptions>
            {user &&
              canAccessUsersPermission &&
              renderOption("userPermissions", () => navigate("/user-permissions"))}
            {/* {user &&
              hasManageRequestPermission &&
              renderOption("requestsManager", () => navigate("/support-requests-manager"))} */}
            {renderOption("signOut", handleLogout)}
          </MenuOptions>
        </MenuContainer>
      )}
    </ClickOutside>
  );
};

export default UserMenu;
